// extracted by mini-css-extract-plugin
export default {"profile":"profile_profile__ShFbv","holdForm":"profile_holdForm__Jv1Cx"};